module.exports = __webpack_public_path__ + "static/media/appstore.85d77449.svg";